module.exports = __webpack_public_path__ + "static/media/Vindermere Combat.ea1d0ef1.jpg";